<div #resizeHandle class="right-sidenav__resize-handle"></div>

<div class="right-sidenav__body">
  <div class="right-sidenav__tab-wrapper">
    <ng-container
      *ngIf="selectedTab() === 'chat' && showChat(); else tasksPane">
      <div class="right-sidenav__tab-content right-sidenav__tab-content--chat">
        <section class="right-sidenav__chat-pane allo-panel">
          <header class="right-sidenav__chat-header allo-header">
            <div class="header-left right-sidenav__chat-brand">
              <div class="allo-logo">
                <div
                  class="allo-icon right-sidenav__chat-logo"
                  aria-hidden="true">
                  <img
                    src="assets/img/allo-ai-logo.svg"
                    alt=""
                    width="24"
                    height="24" />
                </div>
                <span class="allo-title right-sidenav__chat-name">
                  {{ 'GNR_AI_ALLO' | translate }}
                </span>
              </div>
            </div>
            <div class="header-right right-sidenav__chat-actions">
              <button
                class="header-btn new-chat right-sidenav__chat-new-btn"
                [class.header-btn--active]="selectedChatId() === null"
                type="button"
                (click)="startNewChat()"
                [attr.aria-label]="'GNR_NEW_CHAT' | translate"
                [matTooltip]="'GNR_NEW_CHAT' | translate"
                matTooltipPosition="below">
                <mat-icon>add</mat-icon>
                <span class="header-btn__label">{{
                  'GNR_NEW_CHAT' | translate
                }}</span>
              </button>
              <button
                class="header-btn right-sidenav__history-btn"
                type="button"
                (click)="toggleHistory()"
                [class.header-btn--active]="showHistory()"
                [attr.aria-label]="'GNR_HISTORY' | translate"
                [matTooltip]="'GNR_HISTORY' | translate"
                matTooltipPosition="below">
                <mat-icon>history</mat-icon>
                <span class="header-btn__label">{{
                  'GNR_HISTORY' | translate
                }}</span>
              </button>
              <button
                class="popout-btn"
                type="button"
                (click)="openChatInNewWindow()"
                [attr.aria-label]="'GNR_CLICK_OPEN_NEW_WINDOW' | translate"
                [matTooltip]="'GNR_CLICK_OPEN_NEW_WINDOW' | translate"
                matTooltipPosition="below">
                <mat-icon>open_in_new</mat-icon>
              </button>
              <button
                class="popout-btn right-sidenav__close"
                type="button"
                (click)="closePanel()"
                [attr.aria-label]="'CMD_CLOSE' | translate"
                [matTooltip]="'CMD_CLOSE' | translate"
                matTooltipPosition="left">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </header>

          @if (showHistory()) {
            <div class="right-sidenav__history-dropdown history-dropdown">
              @if (chatHistory().length === 0) {
                <span class="right-sidenav__history-empty">
                  {{ 'GNR_NO_CHATS' | translate }}
                </span>
              } @else {
                <div class="right-sidenav__history-list history-list">
                  @for (item of visibleHistory(); track item.id) {
                    <div
                      class="history-item"
                      [class.history-item--active]="
                        selectedChatId() === item.id
                      "
                      [class.history-item--editing]="
                        editingChatId() === item.id
                      ">
                      @if (editingChatId() === item.id) {
                        <input
                          class="history-item-title-input"
                          type="text"
                          [value]="editingTitle()"
                          (input)="onEditingTitleInput($event)"
                          (blur)="saveEditTitle()"
                          (keydown.enter)="
                            saveEditTitle(); $event.preventDefault()
                          "
                          (keydown.escape)="
                            cancelEditTitle(); $event.preventDefault()
                          "
                          (click)="$event.stopPropagation()" />
                      } @else {
                        <div
                          class="history-item__row"
                          (click)="selectChat(item.id)">
                          <span class="history-item-title">
                            {{ item.title || ('GNR_AI_CHAT' | translate) }}
                          </span>
                          <button
                            class="history-item-edit"
                            type="button"
                            (click)="
                              startEditTitle(item); $event.stopPropagation()
                            "
                            aria-label="Edit chat name">
                            <mat-icon>edit</mat-icon>
                          </button>
                        </div>
                        <span class="history-item-preview">
                          {{
                            item.preview ||
                              (item.updatedAt
                                ? (item.updatedAt | date: 'medium')
                                : '')
                          }}
                        </span>
                      }
                    </div>
                  }
                </div>
                @if (hasMoreHistory()) {
                  <button
                    class="view-more-btn"
                    type="button"
                    (click)="showMoreHistory()">
                    View more
                  </button>
                }
              }
            </div>
          }

          <div class="right-sidenav__chat-body chat-body">
            @for (session of [chatSessionKey()]; track session) {
              <qt-ai-chat
                [windowId]="session"
                [chatId]="selectedChatId()"
                [lazySubscribe]="lazyChatSubscribe()"></qt-ai-chat>
            }
          </div>
        </section>
      </div>
    </ng-container>

    <ng-template #tasksPane>
      <div
        class="right-sidenav__tab-content right-sidenav__tab-content--actions">
        <header class="right-sidenav__tasks-header">
          <div class="right-sidenav__tasks-title">
            <mat-icon>checklist</mat-icon>
            <span>{{ 'GNR_MY_TASKS' | translate }}</span>
          </div>
          <button
            mat-icon-button
            class="right-sidenav__close right-sidenav__close--inline"
            type="button"
            (click)="closePanel()"
            [matTooltip]="'CMD_CLOSE' | translate"
            matTooltipPosition="left">
            <mat-icon>close</mat-icon>
          </button>
        </header>
        <mat-divider class="right-sidenav__tasks-divider"></mat-divider>
        <div class="right-sidenav__actions-pane">
          @if (this.selectedTab() === 'tasks' && sidenav.opened) {
            <qt-task-list />
          }
        </div>
      </div>
    </ng-template>
  </div>
</div>
